<template>
    <div class="video-page">
        <van-swipe v-if="videoTopAds.length" class="video-top-swipe" :autoplay="4000" lazy-render touchable>
            <van-swipe-item v-for="ad in videoTopAds" :key="ad.id">
                <a :href="ad.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="ad.pic" alt="" />
                </a>
            </van-swipe-item>
        </van-swipe>

        <van-tabs
            v-if="categories.length"
            v-model="activeTab"
            @change="onTabChange"
            swipeable
            color="#116dff"
            line-width="1rem"
            line-height="0.5rem"
            background="none"
            title-inactive-color="#60718f"
            title-active-color="#116dff"
        >
            <van-tab v-for="item in categories" :key="item.id" :title="item.name || item.classify_name || '未分类'" />
        </van-tabs>

        <div v-if="currentVideoList.length === 0" class="empty-tip">
            暂无视频数据
        </div>

        <div v-else class="video-list">
            <div v-for="item in currentVideoList" :key="item.id" class="video-item">
                <div class="video-main" @click="goPlay(item)">
                    <div class="video-cover">
                        <img v-if="item.cover" :src="item.cover" alt="" />
                        <div v-else class="cover-placeholder">视频封面</div>
                    </div>
                    <div class="video-info">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.description || '暂无简介' }}</p>
                        <div class="meta">
                            <span>{{ item.classify_name || item.category || '未分类' }}</span>
                            <span>{{ item.duration || '未知时长' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-pagination
            v-if="total > pageSize"
            v-model="pageNum"
            :total-items="total"
            :items-per-page="pageSize"
            force-ellipses
            @change="onPageChange"
        />

        <div v-if="videoFloatAd" class="video-float-ad">
            <a :href="videoFloatAd.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                <img :src="videoFloatAd.pic" alt="" />
            </a>
            <div class="close" @click="videoFloatAd = null">x</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoPage',
    data() {
        return {
            categories: [],
            videoList: [],
            activeTab: 0,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            videoTopAds: [],
            videoFloatAd: null
        }
    },
    computed: {
        currentVideoList() {
            return this.videoList || []
        },
        activeClassifyId() {
            const activeCategory = this.categories[this.activeTab]
            if (!activeCategory || Number(activeCategory.id) === 0) return ''
            return Number(activeCategory.id)
        },
        activeClassifyName() {
            const activeCategory = this.categories[this.activeTab]
            if (!activeCategory || Number(activeCategory.id) === 0) return ''
            return String(activeCategory.name || activeCategory.classify_name || '').trim()
        }
    },
    methods: {
        async getCategories() {
            try {
                const { data: res } = await this.$http.get('/video_classify_list')
                const list = res.data || []
                this.categories = [{ id: 0, name: '全部' }, ...list]
                this.activeTab = 0
            } catch (error) {
                this.categories = [{ id: 0, name: '全部' }]
            }
        },
        async getVideoList() {
            try {
                const { data: res } = await this.$http.get('/video_list', {
                    params: {
                        page_num: this.pageNum,
                        page_size: this.pageSize,
                        random: 1,
                        classify_id: this.activeClassifyId || '',
                        classify_name: this.activeClassifyName || ''
                    }
                })
                this.videoList = res.data || []
                this.total = Number(res.paging?.total || 0)
            } catch (error) {
                this.videoList = []
                this.total = 0
            }
        },
        onTabChange() {
            this.pageNum = 1
            this.getVideoList()
        },
        onPageChange(page) {
            this.pageNum = page
            this.getVideoList()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        goPlay(item) {
            if (!item || !item.id) return
            this.$router.push(`/video/play/${item.id}`)
        },
        async getVideoAds() {
            try {
                const [{ data: topRes }, { data: floatRes }] = await Promise.all([
                    this.$http.get('/ad_slot_list', { params: { ad_type: 'video_top' } }),
                    this.$http.get('/ad_slot_list', { params: { ad_type: 'video_float' } })
                ])
                this.videoTopAds = topRes.data || []
                this.videoFloatAd = (floatRes.data || [])[0] || null
            } catch (error) {
                this.videoTopAds = []
                this.videoFloatAd = null
            }
        }
    },
    async created() {
        await this.getCategories()
        await this.getVideoList()
        await this.getVideoAds()
    }
}
</script>

<style lang="less" scoped>
.video-page {
    padding: 0;
    padding-bottom: .4rem;
}

.video-top-swipe {
    width: 100%;
    height: 8.4rem;
    margin-bottom: .8rem;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #f7f8fa;
        border-radius: .95rem;
        box-shadow: 0 12px 26px rgba(2, 6, 23, .4);
    }
}

.empty-tip {
    text-align: center;
    color: #94a3b8;
    padding: 2rem 0;
}

.video-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .7rem;
    margin-top: 1rem;
}

.video-item {
    background: linear-gradient(145deg, rgba(15, 23, 42, 0.95), rgba(9, 14, 34, 0.92));
    border-radius: .92rem;
    border: 1px solid rgba(34, 211, 238, .14);
    box-shadow: var(--a-shadow);
    overflow: hidden;
}

.video-main {
    cursor: pointer;
}

.video-cover {
    width: 100%;
    height: 7.4rem;
    background: rgba(255,255,255,.04);
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.cover-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #cbd5e1;
}

.video-info {
    padding: .6rem;
    h3 {
        font-size: .9rem;
        margin-bottom: .22rem;
        color: #f8fafc;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    p {
        font-size: .76rem;
        color: #94a3b8;
        line-height: 1.35;
        margin-bottom: .4rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.meta {
    display: flex;
    justify-content: space-between;
    color: #22d3ee;
    font-size: .72rem;
    font-weight: 700;
}

.van-pagination {
    margin-top: 1rem;
    padding: 0 0 .8rem;
}

/deep/ .van-tabs__wrap {
    margin-bottom: .5rem;
    background: transparent;
}

/deep/ .van-tab {
    color: #94a3b8;
}

:deep(.van-tab--active) {
    color: #22d3ee;
}

:deep(.van-tabs) {
    background: var(--a-surface);
    border-radius: .9rem;
    border: 1px solid rgba(17, 109, 255, .16);
    padding-top: .2rem;
    box-shadow: var(--a-shadow);
}

.video-float-ad {
    position: fixed;
    right: .4rem;
    top: 42%;
    width: 5rem;
    z-index: 998;
    img {
        width: 100%;
        border-radius: .7rem;
        box-shadow: 0 10px 18px rgba(17, 56, 124, .24);
    }
    .close {
        text-align: center;
        color: #fff;
        font-size: .85rem;
        background: rgba(17, 56, 124, .74);
        border-radius: .3rem;
        margin-top: .2rem;
    }
}

@media screen and (max-width: 360px) {
    .video-list {
        grid-template-columns: 1fr;
    }
}
</style>
